import Actions from '../../odata/actions';

const actions = new Actions('applicationSetting', 'applicationSettings');

export default actions;
